import React from 'react'

const StatusFilter = () => {
  return (
    <div className="flex flex-wrap items-center text-gray-444 text-sm lg:text-base">
      <div><span className="font-bold">All</span> (100)</div>
      <div className="mx-3">|</div>
      <div><span className="text-primary cursor-pointer">Draft</span> (1)</div>
      <div className="mx-3">|</div>
      <div><span className="text-primary cursor-pointer">Under Review</span> (2)</div>
      <div className="mx-3">|</div>
      <div><span className="text-primary cursor-pointer">Approved</span> (93)</div>
    </div>
  )
}

export { StatusFilter }